import { useAuth } from 'resources/Auth'

function useACL(roles = [], { mode = 'allow', omitMainAdmin = false } = {}) {
  const {
    data: { user },
  } = useAuth()

  const isModeAllow = mode === 'allow'

  const hasRole = [isModeAllow && !omitMainAdmin && 'main_admin', ...roles]
    .filter(Boolean)
    ?.some(role => user?.user?.roles?.includes(role))
  return isModeAllow ? !!hasRole : !hasRole
}

export default useACL
